// const getTotal = (statistics, status) => {
//   return statistics.reduce((acc, item) => {
//     if (item.status === status) {
//       return item.total
//     }
//
//     return acc
//   }, 0)
// }

export default {
  afterPrepareShow () {
    if (this.statistics.length > 0) {
      this.absent = this.statistics[0].total_absent
      this.scheduled = this.statistics[0].total_scheduled
      this.canceled = this.statistics[0].total_canceled
      this.attended = this.statistics[0].total_attended
      this.total = this.statistics[0].total_statistic
      this.agendas = this.statistics[0].agendas_active
    }

    // this.total = this.statistics.reduce((acc, item) => {
    //   return acc + item.total
    // }, 0)
  }
  // getTotalAgendasActives () {
  //   this.$http.get('v1/professional/agendas/agendas/total_actives')
  //     .then(({data}) => {
  //       this.agendas = data.total
  //     })
  // }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/statistics/resources/methods.js